import ConnectorList from '../../../components/vehicle/connectors'
import ConnectorStore from '../../../components/vehicle/connectors/context/context'

const ConnectorPage = () => {
  return (
    <ConnectorStore>
      <ConnectorList />
    </ConnectorStore>
  )
}

export default ConnectorPage
